<template>
  <div
    v-if="season === 'H' && stationData.connectedNameDomain && stationData.connectedDomainDescription"
    class="col-12 pt-5 pt-md-5"
  >
    <div v-if="season === 'H'" class="row">
      <!-- Desktop -->
      <div class="d-none d-md-block col-12 justify-content-between">
        <h3 class="title-3 text-grey-900 pt-2 pb-4">
          {{ content.station_ConnectedDomain }}
          {{ stationData.connectedNameDomain }}
        </h3>
      </div>
      <!-- Mobile -->
      <a
        class="d-md-none col-12 w-100 border-1 py-2 py-lg-3"
        data-toggle="collapse"
        type="button"
        data-target="#tf-info-domain-conencted-inner"
        aria-expanded="false"
        aria-controls="tf-info-domain-conencted-inner"
      >
        <div class="d-flex justify-content-between border-top border-gray py-2">
          <div class="title-3 text-grey-900 pt-2">
            {{ content.station_ConnectedDomain }}
            {{ stationData.connectedNameDomain }}
          </div>
          <div class="d-flex d-sm-none align-items-center text-light-blue">
            <svg color="black" width="13" height="13" viewBox="0 0 16 16" class="bi bi-chevron-up" fill="none">
              <use xlink:href="#___icon___chevron-up-bold"></use>
            </svg>
            <svg color="black" width="13" height="13" viewBox="0 0 16 16" class="bi bi-chevron-down" fill="none">
              <use xlink:href="#___icon___chevron-down-bold"></use>
            </svg>
          </div>
        </div>
      </a>

      <div
        data-mobile-collapsed
        data-desktop-expanded
        class="collapse"
        id="tf-info-domain-conencted-inner"
      >
        <div class="d-flex flex-column flex-md-row nowrap row">
          <div class="col-12 col-md-5 justify-content-between">
            <div
              id="connectedDomainDescription"
              ref="connectedDomainDescriptionWrap"
              class="body text-grey-900 pt-4"
            >
              <div
                class="body text-grey-900 show-more-less-text mb-0 mb-md-2"
                v-html="stationData.connectedDomainDescription"
              ></div>
              <div
                class="link-large-underline link-default read-more py-3 cursor-pointer"
              >
                <span>{{ content.station_seeMore }}</span>
                <span>
                  <svg style="color: var(--primary-blue);" width="10" height="10">
                    <use xlink:href="#___icon___chevron-right-bold"></use>
                  </svg>
                </span>
              </div>
              <div
                class="link-large-underline link-default read-less cursor-pointer"
              >
                <span>
                  <span class="pr-1">{{ content.station_seeLess }}</span>
                  <span>
                    <svg style="color: var(--primary-blue);" width="10" height="10">
                      <use xlink:href="#___icon___chevron-up-bold"></use>
                    </svg>
                  </span>
                </span>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-7">
            <SkiAreaStats
              :pisteLength="stationData.domaineReliePistLength"
              :nbSlopes="stationData.connectedDomainNbSlopes"
              :nbSkiLifts="stationData.nbConnectedDomainSkiLifts"
              :data="data"
              :stationData="stationData"
              :content="content"
              :isConnectedDomain="true"
            />
            <SlopesInformation
              v-if="stationData.nbSlopesGreen"
              :nbSlopesGreen="stationData.connectedDomainNbSlopesGreen"
              :nbSlopesBlue="stationData.connectedDomainNbSlopesBlue"
              :nbSlopesRed="stationData.connectedDomainNbSlopesRed"
              :nbSlopesBlack="stationData.connectedDomainNbSlopesBlack"
              :domainName="stationData.connectedNameDomain"
              :content="content"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import TextShowMoreLess from "@/textShowMoreLess/textShowMoreLess.js";
import SkiAreaStats from "./SkiAreaStats.vue";
import SlopesInformation from "./SlopesInformation.vue";

interface ConnectedDomainSectionProps {
  data: Record<string, any>;
  stationData: Record<string, any>;
  season: string;
  content: Record<string, string>;
}

const props = defineProps<ConnectedDomainSectionProps>();
const connectedDomainDescriptionWrap = ref<HTMLElement | null>(null);

const initializeTextShowMoreLess = () => {
  if (connectedDomainDescriptionWrap.value) {
    const textShowMoreLess = new TextShowMoreLess(connectedDomainDescriptionWrap.value, 15);
    textShowMoreLess.init();
  }
};

onMounted(() => {
  initializeTextShowMoreLess();
});
</script> 